// query string params
export const PageParamName = "page";
export const OrderStateParamName = "order_state";

export const ORDERS_PAGE_SIZE = 3;

export const OrderState = {
  InProgress: "inProgress",
  History: "history"
};

export const OrderStatus = {
  AwaitingPayment: "AwaitingPayment",
  Ordered: "Ordered",
  InProduction: "InProduction",
  Sent: "Sent",
  Cancelled: "Cancelled"
};

export const InternalOrderStatus = {
  Received: "Received",
  Confirmed: "Confirmed",
  ProductionStarted: "ProductionStarted",
  ProductionCompleted: "ProductionCompleted",
  Dispatched: "Dispatched",
  Cancelled: "Cancelled"
};

export const ResnapOrderStatus = {
  paymentPending: "paymentPending",
  paymentFailed: "paymentFailed",
  paymentSuccess: "paymentSuccess",
  paymentFree: "paymentFree",
  verificationFailed: "verification failed",
  processing: "processing",
  processingFailed: "processing failed",
  approved: "approved",
  rejected: "rejected",
  on_hold: "on_hold",
  producing: "producing",
  delayed: "delayed",
  shipped: "shipped",
  cancelled: "cancelled"
};

export const OrderStatusMapping = [
  {
    status: OrderStatus.AwaitingPayment,
    internal: [InternalOrderStatus.Received],
    color: "cyan"
  },
  {
    status: OrderStatus.Ordered,
    internal: [InternalOrderStatus.Confirmed],
    color: "cyan"
  },
  {
    status: OrderStatus.InProduction,
    internal: [InternalOrderStatus.ProductionStarted, InternalOrderStatus.ProductionCompleted],
    color: "cyan"
  },
  {
    status: OrderStatus.Sent,
    internal: [InternalOrderStatus.Dispatched],
    color: "cyan"
  },
  {
    status: OrderStatus.Cancelled,
    internal: [InternalOrderStatus.Cancelled],
    color: "red"
  }
];

export const ResnapOrderStatusMapping = [
  {
    resnap: [ResnapOrderStatus.paymentPending, ResnapOrderStatus.paymentFailed],
    internal: InternalOrderStatus.Received
  },
  {
    resnap: [
      ResnapOrderStatus.paymentSuccess,
      ResnapOrderStatus.paymentFree,
      ResnapOrderStatus.verificationFailed,
      ResnapOrderStatus.processing,
      ResnapOrderStatus.processingFailed,
      ResnapOrderStatus.approved,
      ResnapOrderStatus.rejected,
      ResnapOrderStatus.on_hold
    ],
    internal: InternalOrderStatus.Confirmed
  },
  {
    resnap: [ResnapOrderStatus.producing, ResnapOrderStatus.delayed],
    internal: InternalOrderStatus.ProductionStarted
  },
  {
    resnap: [ResnapOrderStatus.shipped],
    internal: InternalOrderStatus.Dispatched
  },
  {
    resnap: [ResnapOrderStatus.cancelled],
    internal: InternalOrderStatus.Cancelled
  }
];

export const OrderSources = {
  Resnap: "Resnap",
  Albelli: "Albelli"
};
